/**
 * Central ID Provider
 * Single source of truth for dynamic tenant identity resolution.
 * Prevents hardcoding and stale module-level exports.
 */

export const getActiveRestaurantSystemId = () => {
  try {
    const stored = localStorage.getItem("restaurant_system_id");
    if (stored && stored.trim()) return stored.trim();

    // Secondary check from stored user
    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user?.restaurant_system_id) return String(user.restaurant_system_id).trim();
      if (user?.restaurant?.system_id) return String(user.restaurant.system_id).trim();
    }
  } catch (e) {
    console.error("Error reading restaurant_system_id:", e);
  }
  return "";
};

export const setActiveRestaurantSystemId = (id) => {
  if (id && String(id).trim()) {
    localStorage.setItem("restaurant_system_id", String(id).trim());
  } else {
    localStorage.removeItem("restaurant_system_id");
  }
};

export const getActiveRestaurantId = () => {
  try {
    const stored = localStorage.getItem("restaurant_id");
    if (stored && stored !== "null" && stored !== "undefined") {
      return String(stored);
    }

    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      const resId = user?.restaurant_id || user?.restaurant?.id;
      if (resId !== undefined && resId !== null && resId !== "") {
        return String(resId);
      }
    }

    const settingsStr = localStorage.getItem("settings");
    if (settingsStr) {
      const settings = JSON.parse(settingsStr);
      const resId = settings?.restaurant_id || settings?.restaurant?.id;
      if (resId !== undefined && resId !== null && resId !== "") {
        return String(resId);
      }
    }
  } catch (e) {
    console.error("Error reading restaurant_id:", e);
  }
  return "1";
};

export const setActiveRestaurantId = (id) => {
  if (id !== undefined && id !== null && id !== "" && id !== "null") {
    localStorage.setItem("restaurant_id", String(id));
  } else {
    localStorage.removeItem("restaurant_id");
  }
};

export const getActiveClientId = () => {
  try {
    const stored = localStorage.getItem("client_id");
    if (stored && stored !== "null" && stored !== "undefined") {
      return String(stored);
    }

    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      const clientId = user?.client_id || user?.client?.id || user?.client?.system_id;
      if (clientId !== undefined && clientId !== null && clientId !== "") {
        return String(clientId);
      }
    }
  } catch (e) {
    console.error("Error reading client_id:", e);
  }
  return "1";
};
